import { createPlugin } from "../createPlugin";
import { PlayerEvent } from "../../Core/PlayerEvents";

/**
 * Chapter markers — agnostic to how chapters were authored (manual, CMS, AI).
 *
 * Chapter shape: { id?, start: number, end?: number, title: string }
 */
export function createChaptersPlugin(options) {
  options = options || {};

  function normalize(list) {
    return (list || [])
      .map(function (c, i) {
        return {
          id: c.id || "ch-" + i,
          start: Number(c.start) || 0,
          end: c.end != null ? Number(c.end) : null,
          title: c.title || "Chapter " + (i + 1),
        };
      })
      .sort(function (a, b) {
        return a.start - b.start;
      });
  }

  return createPlugin({
    name: "chapters",
    version: "0.1.0",
    onRegister: function (ctx) {
      ctx._chapters = {
        list: normalize(options.chapters || ctx.config.chapters || []),
        activeId: null,
      };
    },
    onReady: function (ctx) {
      var list = ctx._chapters.list;
      ctx.bus.emit(PlayerEvent.CHAPTERS_CHANGED, { chapters: list });

      ctx.bus.on("ui:selectChapter", function (idOrStart) {
        var chapter = null;
        for (var i = 0; i < list.length; i++) {
          if (
            list[i].id === idOrStart ||
            list[i].start === idOrStart
          ) {
            chapter = list[i];
            break;
          }
        }
        if (!chapter && typeof idOrStart === "number") {
          chapter = { start: idOrStart, title: "Chapter", id: "tmp" };
        }
        if (!chapter) {
          return;
        }
        ctx._chapters.activeId = chapter.id;
        ctx.engine.seek(chapter.start);
        ctx.bus.emit(PlayerEvent.CHAPTER_SELECTED, { chapter: chapter });
        ctx.bus.emit(PlayerEvent.ANNOUNCEMENT, {
          message: "Chapter: " + chapter.title,
        });
      });

      ctx.bus.on("ui:nextChapter", function () {
        var t = ctx.getState().currentTime || 0;
        for (var i = 0; i < list.length; i++) {
          if (list[i].start > t + 0.25) {
            ctx.bus.emit("ui:selectChapter", list[i].id);
            return;
          }
        }
      });

      ctx.bus.on("ui:prevChapter", function () {
        var t = ctx.getState().currentTime || 0;
        for (var i = list.length - 1; i >= 0; i--) {
          if (list[i].start < t - 0.5) {
            ctx.bus.emit("ui:selectChapter", list[i].id);
            return;
          }
        }
        if (list[0]) {
          ctx.bus.emit("ui:selectChapter", list[0].id);
        }
      });

      // Public API on bus for AI-generated chapter injection
      ctx.bus.on("chapters:set", function (next) {
        ctx._chapters.list = normalize(next);
        ctx.bus.emit(PlayerEvent.CHAPTERS_CHANGED, {
          chapters: ctx._chapters.list,
        });
      });
    },
    onEvent: function (eventName, payload, ctx) {
      if (eventName !== "timeupdate" || !ctx._chapters) {
        return;
      }
      var t = (payload && payload.currentTime) || 0;
      var list = ctx._chapters.list;
      var active = null;
      for (var i = 0; i < list.length; i++) {
        var start = list[i].start;
        var end =
          list[i].end != null
            ? list[i].end
            : list[i + 1]
              ? list[i + 1].start
              : Infinity;
        if (t >= start && t < end) {
          active = list[i];
          break;
        }
      }
      if (active && active.id !== ctx._chapters.activeId) {
        ctx._chapters.activeId = active.id;
        ctx.bus.emit(PlayerEvent.CHAPTER_SELECTED, {
          chapter: active,
          fromPlayback: true,
        });
      }
    },
  });
}

export default createChaptersPlugin;
